module.exports = __webpack_public_path__ + "img/Qq.e3b3ddc2.png";